module.exports = __webpack_public_path__ + "img/Kevin Rabichow.d9344b5a.png";